<template>
<!--  <CFooter :fixed="false">-->
<!--    <div>-->
<!--      <a href="#" target="_blank">Exodus</a>-->
<!--      <span class="ml-1">&copy; {{new Date().getFullYear()}} Labs.</span>-->
<!--    </div>-->
<!--    <div class="ml-auto">-->
<!--      <span class="mr-1">Powered by</span>-->
<!--      <a href="#" target="_blank">Vue</a>-->
<!--    </div>-->
<!--  </CFooter>-->
  <div>
    <div class="fixed">
      <transition name="fade">
        <div class="alert alert-success" role="alert" v-if="clicked">
          <span style="font-style: italic; font-weight: bold"> {{clickedLink}} </span> address copied to clipboard
        </div>
      </transition>
    </div>

    <CFooter class="footer-distributed">

      <div class="footer-left">

        <h3>Company<span>logo</span></h3>

        <p class="footer-company-name">Starter Grower | Resilient © 2021</p>
      </div>

      <div class="footer-right">

        <p class="footer-company-about">
          <span class="my-3">Make donation</span>
          Thank you for using the Free Starter Grower. If you like these kinds of projects, please consider donating some crypto to the developer to keep paying the programmer to make frequent updates!
        </p>

        <p class="footer-links">
          <copy-to-clipboard :text="BTC" @copy="handleCopy">
            <a href="#" class="link-1">BTC</a>
          </copy-to-clipboard>
          <copy-to-clipboard :text="ETH" @copy="handleCopy">
            <a href="#">ETH</a>
          </copy-to-clipboard>
          <copy-to-clipboard :text="BCH" @copy="handleCopy">
            <a href="#">BCH</a>
          </copy-to-clipboard>
          <copy-to-clipboard :text="USDC" @copy="handleCopy">
            <a href="#">USDC</a>
          </copy-to-clipboard>
          <copy-to-clipboard :text="XLM" @copy="handleCopy">
            <a href="#">XLM</a>
          </copy-to-clipboard>
        </p>
      </div>

    </CFooter>
  </div>
</template>

<script>
import CopyToClipboard from 'vue-copy-to-clipboard'

export default {
  name: 'TheFooter',
  components: {
    CopyToClipboard
  },
  data() {
    return {
      BTC: '342ehFKvZAnZLCM2TCX5b3qSj1JMWJDBx7',
      ETH: '0xE45E7ec2493bfb7404744fE583A6688245731BC4',
      BCH: 'qrvv6m0hwvcsg6plmpq0nlgzmahvcr7ceggukasydv',
      USDC: '0xFfB17B08AA6B7d007940dc39347951D8F27bf9c6',
      XLM: 'GDQP2KPQGKIHYJGXNUIYOMHARUARCA7DJT5FO2FFOOKY3B2WSQHG4W37',
      clicked: false,
      clickedLink: ''
    }
  },
  methods: {
    handleCopy (result) {
      console.log('onCopy', result)
      let self = this
      if (result === self.BTC) {
        self.clickedLink = 'Bitcoin'
      } else if (result === self.ETH) {
        self.clickedLink = 'Ethereum'
      } else if (result === self.BCH) {
        self.clickedLink = 'Bitcoin Cash'
      } else if (result === self.USDC) {
        self.clickedLink = 'USD Coin'
      } else if (result === self.XLM) {
        self.clickedLink = 'Lumen'
      } else {
        console.log('error in selecting donation')
      }

      self.clicked = true
      setTimeout(function () {
        self.clicked = !self.clicked
      }.bind(this), 5000);
    },
    copyTestingCode () {
      let testingCodeToCopy = document.querySelector('#testing-code')
      testingCodeToCopy.setAttribute('type', 'text')
      testingCodeToCopy.select()

      try {
        let successful = document.execCommand('copy');
        let msg = successful ? 'successful' : 'unsuccessful';
        alert('Testing code was copied ' + msg);
      } catch (err) {
        alert('Oops, unable to copy');
      }

      /* unselect the range */
      testingCodeToCopy.setAttribute('type', 'hidden')
      window.getSelection().removeAllRanges()
    },
  }
}
</script>

<style>

@import url(https://fonts.googleapis.com/css?family=Open+Sans:400,500,300,700);

.fixed {
  /*position: fixed;*/
  width: 20%;
  bottom: 10px;
  z-index: 1;
  right: 2%;
  float: right;
}

* {
  font-family: Open Sans;
}

.footer-distributed{
  background: #666;
  box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.12);
  box-sizing: border-box;
  width: 100%;
  text-align: left;
  font: bold 16px sans-serif;
  padding: 55px 50px;

  height: 27vh;
}

.footer-distributed .footer-left,
.footer-distributed .footer-center,
.footer-distributed .footer-right{
  display: inline-block;
  vertical-align: top;
}

/* Footer left */

.footer-distributed .footer-left{
  width: 250px;
}

/* The company logo */

.footer-distributed h3{
  color:  #ffffff;
  font: normal 36px 'Open Sans', cursive;
  margin: 0;
}

.footer-distributed h3 span{
  color:  lightseagreen;
}

/* Footer links */

.footer-distributed .footer-links{
  color:  #ffffff;
  margin: 20px 0 12px;
  padding: 0;
}

.footer-distributed .footer-links a{
  display:inline-block;
  line-height: 1.8;
  font-weight:400;
  text-decoration: none;
  color:  inherit;
}

.footer-distributed .footer-company-name{
  color:  #222;
  font-size: 14px;
  font-weight: normal;
  margin: 0;
}

/* Footer Center */

.footer-distributed .footer-center{
  width: 35%;
}

.footer-distributed .footer-center i{
  background-color:  #33383b;
  color: #ffffff;
  font-size: 25px;
  width: 38px;
  height: 38px;
  border-radius: 50%;
  text-align: center;
  line-height: 42px;
  margin: 10px 15px;
  vertical-align: middle;
}

.footer-distributed .footer-center i.fa-envelope{
  font-size: 17px;
  line-height: 38px;
}

.footer-distributed .footer-center p{
  display: inline-block;
  color: #ffffff;
  font-weight:400;
  vertical-align: middle;
  margin:0;
}

.footer-distributed .footer-center p span{
  display:block;
  font-weight: normal;
  font-size:14px;
  line-height:2;
}

.footer-distributed .footer-center p a{
  color:  lightseagreen;
  text-decoration: none;;
}

.footer-distributed .footer-links a:before {
  content: "|";
  font-weight:300;
  font-size: 20px;
  left: 0;
  color: #fff;
  display: inline-block;
  padding-right: 5px;
}

.footer-distributed .footer-links .link-1:before {
  content: none;
}

/* Footer Right */

.footer-distributed .footer-right{
  width: 70%;
}

.footer-distributed .footer-company-about{
  line-height: 20px;
  color:  #92999f;
  font-size: 13px;
  font-weight: normal;
  margin: 0;
}

.footer-distributed .footer-company-about span{
  display: block;
  color:  #ffffff;
  font-size: 14px;
  font-weight: bold;
  margin-bottom: 20px;
}

.footer-distributed .footer-icons{
  margin-top: 25px;
}

.footer-distributed .footer-icons a{
  display: inline-block;
  width: 35px;
  height: 35px;
  cursor: pointer;
  background-color:  #33383b;
  border-radius: 2px;

  font-size: 20px;
  color: #ffffff;
  text-align: center;
  line-height: 35px;

  margin-right: 3px;
  margin-bottom: 5px;
}

/* If you don't want the footer to be responsive, remove these media queries */

@media (max-width: 880px) {

  .footer-distributed{
    font: bold 14px sans-serif;
  }

  .footer-distributed .footer-left,
  .footer-distributed .footer-center,
  .footer-distributed .footer-right{
    display: block;
    width: 100%;
    margin-bottom: 40px;
    text-align: center;
  }

  .footer-distributed .footer-center i{
    margin-left: 0;
  }

  @media (max-width: 768px) {
    .footer-distributed {
      height: 40vh;
    }
  }
  @media (max-width: 320px) {
    .footer-distributed {
      height: 50vh;
    }
  }
  @media (max-width: 375px) {
    .footer-distributed{
      height: 50vh;
    }
  }
  @media (max-width: 425px) {
    .footer-distributed{
      height: 50vh;
    }
  }
}

</style>
